import { FileType } from '@/types/types';

export const PDF_ONLY_UPLOAD_TOOLS = [
  'compress',
  'rotate-pdf',
  'split-pdf',
  'delete-pdf-pages',
  'extract-pdf-pages',
  'edit-pdf',
  'annotate-pdf',
  'protect-pdf',
  'unlock-pdf',
] as const;

export const PDF_ONLY_FILE_TYPES: FileType[] = ['pdf'];

export const CONVERTIBLE_UPLOAD_FILE_TYPES: FileType[] = [
  'pdf',
  'doc',
  'docx',
  'ppt',
  'pptx',
  'xls',
  'xlsx',
  'jpg',
  'jpeg',
  'png',
];

export const PDF_TO_WORD_FILE_TYPES: FileType[] = ['pdf'];

export const WORD_TO_PDF_FILE_TYPES: FileType[] = ['doc', 'docx'];

export const PDF_TO_EXCEL_FILE_TYPES: FileType[] = ['pdf'];

export const EXCEL_TO_PDF_FILE_TYPES: FileType[] = ['xls', 'xlsx'];

export const PDF_TO_POWERPOINT_FILE_TYPES: FileType[] = ['pdf'];

export const POWERPOINT_TO_PDF_FILE_TYPES: FileType[] = ['ppt', 'pptx'];

export const PDF_TO_IMAGE_FILE_TYPES: FileType[] = ['pdf'];

export const IMAGE_TO_PDF_FILE_TYPES: FileType[] = ['jpg', 'jpeg', 'png'];
export const MERGE_PDF_FILE_TYPES: FileType[] = ['pdf', 'jpg', 'jpeg', 'png'];
export const MERGE_JPG_TO_PDF_FILE_TYPES = MERGE_PDF_FILE_TYPES;
export const COMBINE_JPG_TO_PDF_FILE_TYPES = MERGE_PDF_FILE_TYPES;
export const MERGE_PNG_TO_PDF_FILE_TYPES = MERGE_PDF_FILE_TYPES;

const TOOL_UPLOAD_FILE_TYPES_MAP: Partial<Record<string, FileType[]>> = {
  compress: PDF_ONLY_FILE_TYPES,
  'rotate-pdf': PDF_ONLY_FILE_TYPES,
  'split-pdf': PDF_ONLY_FILE_TYPES,
  'delete-pdf-pages': PDF_ONLY_FILE_TYPES,
  'extract-pdf-pages': PDF_ONLY_FILE_TYPES,
  'convert-pdf': CONVERTIBLE_UPLOAD_FILE_TYPES,
  'pdf-converter': CONVERTIBLE_UPLOAD_FILE_TYPES,
  'pdf-to-word': PDF_TO_WORD_FILE_TYPES,
  'word-to-pdf': WORD_TO_PDF_FILE_TYPES,
  'word-to-pdf-converter': WORD_TO_PDF_FILE_TYPES,
  'pdf-to-word-converter': PDF_TO_WORD_FILE_TYPES,
  'pdf-to-excel': PDF_TO_EXCEL_FILE_TYPES,
  'excel-to-pdf': EXCEL_TO_PDF_FILE_TYPES,
  'excel-to-pdf-converter': EXCEL_TO_PDF_FILE_TYPES,
  'pdf-to-excel-converter': PDF_TO_EXCEL_FILE_TYPES,
  'pdf-to-ppt': PDF_TO_POWERPOINT_FILE_TYPES,
  'ppt-to-pdf': POWERPOINT_TO_PDF_FILE_TYPES,
  'ppt-to-pdf-converter': POWERPOINT_TO_PDF_FILE_TYPES,
  'pdf-to-ppt-converter': PDF_TO_POWERPOINT_FILE_TYPES,
  'pdf-to-jpg': PDF_TO_IMAGE_FILE_TYPES,
  'jpg-to-pdf': IMAGE_TO_PDF_FILE_TYPES,
  'image-to-pdf-converter': IMAGE_TO_PDF_FILE_TYPES,
  'merge-pdf': MERGE_PDF_FILE_TYPES,
  'merge-jpg-to-pdf': MERGE_JPG_TO_PDF_FILE_TYPES,
  'combine-jpg-to-pdf': COMBINE_JPG_TO_PDF_FILE_TYPES,
  'merge-png-to-pdf': MERGE_PNG_TO_PDF_FILE_TYPES,
  'pdf-to-image-converter': PDF_TO_IMAGE_FILE_TYPES,
  'pdf-ocr': PDF_ONLY_FILE_TYPES,
  'edit-pdf': PDF_ONLY_FILE_TYPES,
  'pdf-editor': PDF_ONLY_FILE_TYPES,
  'annotate-pdf': PDF_ONLY_FILE_TYPES,
  'pdf-annotator': PDF_ONLY_FILE_TYPES,
  'protect-pdf': PDF_ONLY_FILE_TYPES,
  'unlock-pdf': PDF_ONLY_FILE_TYPES,
};

export const isPdfOnlyUploadTool = (tool?: string | null) =>
  Boolean(
    tool &&
      PDF_ONLY_UPLOAD_TOOLS.includes(
        tool as (typeof PDF_ONLY_UPLOAD_TOOLS)[number]
      )
  );

export const getUploadFileTypesForTool = (tool?: string | null): FileType[] =>
  tool && TOOL_UPLOAD_FILE_TYPES_MAP[tool]
    ? [...(TOOL_UPLOAD_FILE_TYPES_MAP[tool] as FileType[])]
    : isPdfOnlyUploadTool(tool)
      ? [...PDF_ONLY_FILE_TYPES]
      : [...CONVERTIBLE_UPLOAD_FILE_TYPES];

export const buildAcceptedFileTypes = (fileTypes: FileType[] = ['pdf']) =>
  fileTypes.map((type) => `.${type}`).join(', ');

export const buildUploadFormatDisplay = (fileTypes: FileType[] = ['pdf']) =>
  Array.from(new Set(fileTypes.length > 0 ? fileTypes : ['pdf']))
    .map((type) => type.toUpperCase())
    .join(', ');
